export default __webpack_public_path__ + "static/media/Montserrat-Medium.2a3e005f.woff";